import { FC, CSSProperties } from 'react';
import { IconButton, IconButtonProps, makeStyles } from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import clsx from 'clsx';

export type WbExpandToggleProps = IconButtonProps & {
  expanded: boolean;
  iconClassName?: string;
  iconStyle?: CSSProperties;
};

const useStyles = makeStyles(
  theme => ({
    root: {},
    expandIcon: {
      transform: 'rotate(0deg)',
      '&$expanded': {
        transform: `rotate(90deg)`,
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expanded: {},
  }),
  { name: 'WbExpandToggle' },
);

export const WbExpandToggle: FC<WbExpandToggleProps> = ({
  expanded,
  className,
  size = 'small',
  iconClassName,
  iconStyle,
  ...props
}) => {
  const classes = useStyles();

  const Icon = KeyboardArrowRightIcon;

  return (
    <IconButton
      aria-label={expanded ? 'collapse' : 'expand'}
      className={clsx(
        className,
        classes.expandIcon,
        expanded && classes.expanded,
      )}
      size={size}
      {...props}
    >
      <Icon className={iconClassName} style={iconStyle} />
    </IconButton>
  );
};
